var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9C3.344 9 2 10.344 2 12L2 34C2 35.656 3.344 37 5 37H37C38.656 37 40 35.656 40 34V12C40 10.344 38.656 9 37 9H26V7H37C39.762 7 42 9.238 42 12V34C42 36.762 39.762 39 37 39H5C2.238 39 0 36.762 0 34L0 12C0 9.238 2.238 7 5 7L16 7V9H5Z",
    fill: "#00CFC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0.999961C16 0.447983 16.448 0 17 0L25 0C25.552 0 26 0.447983 26 0.999961V10.9996C26 11.3776 25.786 11.7256 25.448 11.8936L21.448 13.8935C21.166 14.0355 20.834 14.0355 20.552 13.8935L16.552 11.8936C16.214 11.7256 16 11.3776 16 10.9996V0.999961ZM18 1.99992V10.3816L21 11.8815L24 10.3816V1.99992L18 1.99992Z",
    fill: "#00CFC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 20H24V18H30V20Z",
    fill: "#00CFC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 27H24V25H36V27Z",
    fill: "#00CFC5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 18C11.344 18 10 19.344 10 21C10 22.656 11.344 24 13 24C14.656 24 16 22.656 16 21C16 19.344 14.656 18 13 18ZM8 21C8 18.238 10.238 16 13 16C15.762 16 18 18.238 18 21C18 23.762 15.762 26 13 26C10.238 26 8 23.762 8 21Z",
    fill: "#00CFC5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 28C10.238 28 8 30.238 8 33H6C6 29.134 9.134 26 13 26C16.866 26 20 29.134 20 33H18C18 30.238 15.762 28 13 28Z",
    fill: "#00CFC5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLis);
export default __webpack_public_path__ + "static/media/lis.2bda2aa2b04c04515145d4480c1f4466.svg";
export { ForwardRef as ReactComponent };